module.exports = __webpack_public_path__ + "static/media/WIGME.2ba05887.PNG";